import { ref } from 'vue'

const nextId = ref(0)
const getId = () => nextId.value += 1

/**
 * Composable function which returns a numerical ID generator
 * @returns Object containing `getId` function which generates new IDs with each invocation.
 */
export default function useIdGenerator () {
  return {
    getId
  }
}